import { combineNullableStrings } from "../../../utilities/internal/combineNullableStrings.js";
import { useFieldContext } from "./FieldContext.js";
const useInputAccessibilityProps = ({ ariaDescribedBy })=>{
    const inputContext = useFieldContext();
    return {
        id: inputContext?.inputId,
        'aria-describedby': combineNullableStrings(ariaDescribedBy, ...inputContext?.descriptionIds ?? []),
        'aria-invalid': inputContext?.status === 'error',
        'aria-errormessage': inputContext?.status === 'error' ? inputContext?.errorMessageIds.join(' ') || void 0 : void 0
    };
};
export { useInputAccessibilityProps };
